import { messages as portugueseMessages } from './pt'
import { messages as englishMessages } from './en'
import { messages as spanishMessages } from './es'

const portuguese = portugueseMessages.pt || {}

const messages = {
  ...portugueseMessages,
  'pt-BR': {
    ...portuguese,
  },
  ...englishMessages,
  ...spanishMessages,
}

export { messages }
